varying vec3 vViewNormal;
varying vec3 vViewPosition;
varying vec2 vUv;




void main() {
    // Position dans l'espace vue (caméra locale)
    vec4 viewPosition = modelViewMatrix * vec4(position, 1.0);
    vViewPosition = viewPosition.xyz;

    // vec3 dir = normalize(position);
    // position += dir*noise;

    // Normale transformée dans l'espace vue
    vViewNormal = normalize(normalMatrix * normal);

    // Projection finale
    gl_Position = projectionMatrix * viewPosition;

    vUv = uv;
}
